import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../utils/authContext";
import { AuthPassProvider, usePassAuth } from "../utils/passwordContext";

export default function ProtectedRoute({ children, flag }) {
  let location = useLocation();
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
}
export function ProtectedPassRoute({ children }) {
  const { isAuthenticated } = usePassAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
}

// export const WrapperComponent = () => {
//   return (
//     <AuthPassProvider>
//       <ProtectedPassRoute />
//     </AuthPassProvider>
//   );
// };
// export default ProtectedRoute;
